import {RouterState} from "connected-react-router";
import {LocationState} from "history";

export type WorkforceRoute = LocationState;

export interface CurrentUserPermissions {
    "CanShowClinicAdminSetup": boolean,
    "CanShowInvitation": boolean,
    "CanShowRolePermissionSubscription": boolean,
    "CanShowNotification": boolean,
    "CanShowClientInvitationStatus": boolean,
    "CanShowUserInvitationStatus": boolean,
    "CanShowPortal": boolean,
    "CanShowInvitationStatus": boolean,
    "CanViewSiteSearch": boolean,
    "CanViewOrder": boolean,
    "CanViewTracking": boolean,
    "CanViewCompleted": boolean,
    "CanInviteClientUser": boolean,
    "CanManageClient": boolean,
    "CanCreateClient": boolean,
    "CanCreateInstance": boolean,
    "CanEditPendingOrders": boolean,
    "CanViewRandomTesting": boolean,
    "CanManageClientUser": boolean,
    "CanManageInstanceUser": boolean,
    "CanViewPersonnel": boolean,
    "CanViewOrderTrackingGrid": boolean,
    "CanManageServiceEvent": boolean,
    "CanVieweCCFCopy2PreMRO": boolean,
    "CanViewOrderSummary": boolean,
    "CanManagePersonnel": boolean,
    "CanManagePools": boolean,
    "CanCompleteEvents": boolean,
    "CanUploadImages": boolean,
    "CanViewAddressAlert": boolean,
    "CanSearchDefaults": boolean,
    "CanGroupInclude": boolean,
    "CanManageOrphanResults": boolean,
    "CanEditPersonnel": boolean,
    "CanManageSelectionInbox": boolean,
    "CanManageGovDonors": boolean,
    "CanManageGovPools": boolean,
    "CanManageConsortiumPools": boolean,
    "CanOrderGovServices": boolean,
    "CanViewMISReports": boolean,
    "CanMergeTests": boolean,
    "CanMatchTests": boolean
}
export interface CurrentSelectedCompanyPermissions{
    "CanShowClinicAdminSetup": boolean,
    "CanShowInvitation": boolean,
    "CanShowRolePermissionSubscription": boolean,
    "CanShowNotification": boolean,
    "CanShowClientInvitationStatus": boolean,
    "CanShowUserInvitationStatus": boolean,
    "CanShowPortal": boolean,
    "CanShowInvitationStatus": boolean,
    "CanViewSiteSearch": boolean,
    "CanViewOrder": boolean,
    "CanViewTracking": boolean,
    "CanViewCompleted": boolean,
    "CanInviteClientUser": boolean,
    "CanManageClient": boolean,
    "CanCreateClient": boolean,
    "CanCreateInstance": boolean,
    "CanEditPendingOrders": boolean,
    "CanViewRandomTesting": boolean,
    "CanManageClientUser": boolean,
    "CanManageInstanceUser": boolean,
    "CanViewPersonnel": boolean,
    "CanViewOrderTrackingGrid": boolean,
    "CanManageServiceEvent": boolean,
    "CanVieweCCFCopy2PreMRO": boolean,
    "CanViewOrderSummary": boolean,
    "CanManagePersonnel": boolean,
    "CanManagePools": boolean,
    "CanCompleteEvents": boolean,
    "CanUploadImages": boolean,
    "CanViewAddressAlert": boolean,
    "CanSearchDefaults": boolean,
    "CanGroupInclude": boolean,
    "CanManageOrphanResults": boolean,
    "CanEditPersonnel": boolean,
    "CanManageSelectionInbox": boolean,
    "CanManageGovDonors": boolean,
    "CanManageGovPools": boolean,
    "CanManageConsortiumPools": boolean,
    "CanOrderGovServices": boolean,
    "CanViewMISReports": boolean,
    "CanMergeTests": boolean,
    "CanMatchTests": boolean
}
export const SiteAdminRole = 'SiteAdmin'
export const CompanyRole = 'CompanyAdmin'
export const PortalAdmin = 'PortalAdmin'
export const LocationAdmin = 'LocationAdmin'
export const NoAdminRole = 'None'
export type adminRoleType = 'None' |'SiteAdmin' | 'CompanyAdmin' |'PortalAdmin' | 'LocationAdmin'
export interface UserState{
    webToken?: string
    userName?: string
    isLoading: boolean
    isLoggedIn: boolean
    showCompanySelection: boolean
    loadedSelectedCompanyPermission: boolean
    role: adminRoleType
    currentUserPermissions: CurrentUserPermissions
    loadingCompany?: string
    selectedCompany?: string
    requireCompleteSetup?: boolean
    link?: string
    currentCompanyPermissions?: CurrentSelectedCompanyPermissions
    loginResultMessage?: string
}
export interface AssignedClinic {
    ParticipationID: string
    Link: string
    ImplementationName?: string
    Name: string
    RoleID: number
    UserName: string
    AccountID?: number
    LocationID?: number
    LocationName?: string
}
export interface WorkforceClinicPortal {
    ParticipationID?: string
    Link?: string
    Title?: string
    ImplementationName?: string
    RoleID?: number
    AssignedClientDetailsOfClinic: AssignedClinic[]
    ImplementationID?: number
    UnmaskDonorID: number
    NoLabAccount: number
}
export interface CompaniesState {
    visibleCompanies: WorkforceClinicPortal[]
}
export interface AppState {
    Workforce1State: UserState,
    Workforce1Companies: CompaniesState,
    router: RouterState<WorkforceRoute>,
}
